module.exports = __webpack_public_path__ + "img/submit-suffix.ab82fbaf.png";